/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Pausedat1Inputs */

const de__field_pausedat1 = /** @type {(inputs: _Field_Pausedat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pausiert seit`)
};

/**

* @param {_Field_Pausedat1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_pausedat1 = /** @type {((inputs?: _Field_Pausedat1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Pausedat1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_pausedat1(inputs)
});
export { _field_pausedat1 as "_field_pausedAt" }